import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Pallet.css';

function Pallet({ pinnedApps, onUnpin, unreadCount = 0 }) {
  const navigate = useNavigate();

  const handleAppClick = (appId) => {
    const routes = {
      'defects': '/defect-tracker',
      'features': '/feature-requests',
      'notes': '/notes',
      'messaging': '/messaging'
    };
    
    navigate(routes[appId] || '/dashboard');
  };

  const handleContextMenu = (e, app) => {
    e.preventDefault();
    if (window.confirm(`Unpin ${app.title} from pallet?`)) {
      onUnpin(app.appId);
    }
  };

  return (
    <div className="desktop-pallet">
      <div className="pallet-apps">
        {pinnedApps.sort((a, b) => a.order - b.order).map(app => (
          <div
            key={app.appId}
            className="pallet-app"
            onClick={() => handleAppClick(app.appId)}
            onContextMenu={(e) => handleContextMenu(e, app)}
            title={app.title}
          >
            <div className="pallet-app-icon">
              {app.icon}
              {app.appId === 'messaging' && unreadCount > 0 && (
                <div className="pallet-badge">{unreadCount > 99 ? '99+' : unreadCount}</div>
              )}
            </div>
            <div className="pallet-app-title">{app.title}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Pallet;
